<template>
  <Modal
    :modal-types="[END_INTERACTIVE_TOUR_MODAL]"
    :should-add-content-padding="false"
    :is-wide-modal="true"
  >
    <div class="interactive-tour-modal">
      <div class="interactive-tour-modal-header-image">
        <img
          src="//d.stockcharts.com/img/bg-modal-header-02.jpg"
          alt="StockCharts Tour"
        />
      </div>
      <div class="interactive-tour-modal-body">
        <h2 class="interactive-tour-heading">
          Thanks for taking a tour of the new SharpCharts&nbsp;Workbench
        </h2>
        <div class="interactive-tour-info">
          <div>
            We hope this brief overview has helped give you a better sense of all that's available here on the new workbench.
            We've only scratched the surface of what you can do with SharpCharts, but you can learn more and dig deeper into the platform at the following&nbsp;link:
          </div>
          <div class="documentation-link-container">
            <a
              href="//help.stockcharts.com/charts-and-tools/sharpcharts"
              target="_blank"
              rel="noopener noreferrer"
              class="sc3-button-link">SharpCharts Help Docs</a>
          </div>
          <div>
            If you have any questions at all, you can reach out to our Support Team
            <a
              class="sc3-button-link support-button-link"
              href="/support/techsupport.html"
              target="_blank"
              title="Support"
            >here</a>.
            We're here to help you and would love to answer anything you've got!
          </div>
        </div>
        <div>
          <button
            type="button"
            class="sc3-button sc3-button-green sc3-button-extra-large"
            @click="[endInteractiveTour(), closeModal()]"
          >
            Get&nbsp;Started
          </button>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script lang="ts" setup>
  import { useModals } from '@/composables/useModals';
  import { useInteractiveTour } from '@/composables/useInteractiveTour';
  import Modal from '@/components/modals/Modal.vue';

  const { END_INTERACTIVE_TOUR_MODAL, closeModal } = useModals();
  const { endInteractiveTour } = useInteractiveTour();
</script>

<style scoped>
  .interactive-tour-modal {
    text-align: center;
  }

  .interactive-tour-modal-header-image {
    border-radius: 6px 6px 0px 0px;
  }

  .interactive-tour-modal-header-image img {
    max-width: 100%;
  }

  .interactive-tour-modal-body {
    padding: 10px;
  }

  .interactive-tour-heading {
    font-family: 'Roboto Condensed', 'Lato', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-weight: 900;
    font-size: 25px;
  }

  .interactive-tour-info div {
    margin-bottom: 10px;
    color: #707f8f;
    font-size: 15px;
  }

  .support-button-link {
    font-size: unset;
    vertical-align: unset;
    margin: 0px;
  }

  .documentation-link-container {
    margin: 20px 0px !important;
  }

  .documentation-link-container a {
    font-size: 17px;
  }
</style>
